import { DateTime } from '@ksyos/date-time';
import globalize from 'globalize';
import type { LanguageCode } from '@common/translate/translate';
import type { TranslationKey } from '@common/translate/types';
import { doesTranslateKeyExistLang, getLanguage, translateKeyLang } from '@common/translate/translate';

let currentLanguageCode: LanguageCode = 'en';

export function setLanguageCode(languageCode: string) {
    if (languageCode === 'en' || languageCode === 'nl') {
        currentLanguageCode = languageCode;
        globalize.locale(currentLanguageCode);
    } else {
        throw new Error(`Invalid language code "${languageCode}"`);
    }
}

export function getLanguageCode() {
    return currentLanguageCode;
}

export function doesTranslateKeyExist(key: TranslationKey): boolean {
    return doesTranslateKeyExistLang(currentLanguageCode, key);
}

export function getSelectedLanguage() {
    return getLanguage(currentLanguageCode);
}
/**
 * @deprecated Please use formatString (src/common/utils/formatString.ts) instead
 */
export function translateKey(key: TranslationKey, variable0?: string, variable1?: string, variable2?: string): string {
    return translateKeyLang(currentLanguageCode, key, variable0, variable1, variable2);
}

export function getGlobalize() {
    return globalize;
}

export function parseDateInput(input: string, birthDate: boolean) {
    return parseDate(input.trim(), birthDate, getLanguageCode());
}

// for when someone puts a data in like '020301' it will parse to 02-03-2001 or 03/02/2001
export function parseDate(input: string, birthDate: boolean, languageCode: string) {
    if (input === '') {
        // DateTimePicker does not accept undefined/null/'' as parse value
        return 'Invalid Date';
    }

    let parsedDate;
    if (!isNaN(input as any)) {
        if (input.length !== 6 && input.length !== 8) {
            return 'Invalid Date';
        }
        let year;
        if (input.length === 6) {
            // Bug if year needs to be >= 2100
            year = Number('20' + input.slice(4, 6));
            if (birthDate && year > DateTime.now().year()) {
                year = year - 100;
            }
        } else {
            year = input.slice(4, 8);
        }

        switch (languageCode) {
            case 'nl':
                parsedDate = `${year}-${input.slice(2, 4)}-${input.slice(0, 2)}`;
                break;
            case 'en':
            default:
                parsedDate = `${year}-${input.slice(0, 2)}-${input.slice(2, 4)}`;
        }
        if (!parsedDate.match(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/)) {
            return 'Invalid Date';
        }
    } else {
        const splitInput = input.split(/\D/);
        if (splitInput.length !== 3) {
            return 'Invalid Date';
        }

        switch (languageCode) {
            case 'nl':
                parsedDate = `${splitInput[2]}-${splitInput[1].padStart(2, '0')}-${splitInput[0].padStart(2, '0')}`;
                break;
            case 'en':
            default:
                parsedDate = `${splitInput[2]}-${splitInput[0].padStart(2, '0')}-${splitInput[1].padStart(2, '0')}`;
        }
        if (!parsedDate.match(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/)) {
            return 'Invalid Date';
        }
    }

    return DateTime.parseUtcExact(parsedDate, 'YYYY-MM-DD').toDate();
}
